import { Button, Typography } from "@mui/material";

import { PERMISSIONS } from "@/constants/permissions";

import PermissionGuard from "./PermissionGuard";

/**
 * PermissionGuard usage example
 */
const PermissionGuardExample = () => {
    return (
        <div>
            <Typography variant="h6">Normal Content (No Permission Required)</Typography>

            <PermissionGuard permissions={[PERMISSIONS.AUTH_SVC_USER_LIST]}>
                <Typography variant="body1" sx={{ mt: 2, color: "primary.main" }}>
                    This content is only shown to users with the AUTH_SVC_USER_LIST permission
                </Typography>
                <Button variant="contained" color="primary">
                    View User List
                </Button>
            </PermissionGuard>

            <PermissionGuard
                permissions={[PERMISSIONS.AUTH_SVC_PERMISSIONS_GROUPS_CREATE]}
                fallback={
                    <Typography variant="body2" sx={{ mt: 2, color: "text.secondary" }}>
                        You do not have permission to view this content.
                    </Typography>
                }
            >
                <Typography variant="body1" sx={{ mt: 2, color: "success.main" }}>
                    This content is only shown to users with the AUTH_SVC_PERMISSIONS_GROUPS_CREATE permission
                </Typography>
                <Button variant="contained" color="success">
                    Create New Permission Group
                </Button>
            </PermissionGuard>

            {/* "any" mode with - any permission is sufficient */}
            <PermissionGuard
                permissions={[
                    PERMISSIONS.AUTH_SVC_PERMISSIONS_GROUPS_UPDATE,
                    PERMISSIONS.AUTH_SVC_PERMISSIONS_GROUPS_DELETE,
                ]}
                mode="any"
                fallback={
                    <Typography variant="body2" sx={{ mt: 2, color: "error.main" }}>
                        You must have permission to update or delete this content.
                    </Typography>
                }
            >
                <Typography variant="body1" sx={{ mt: 2, color: "warning.main" }}>
                    This content is shown to users with at least one of the listed permissions
                </Typography>
                <Button variant="contained" color="warning" sx={{ mr: 1 }}>
                    Edit
                </Button>
                <Button variant="contained" color="error">
                    Delete
                </Button>
            </PermissionGuard>
        </div>
    );
};

export default PermissionGuardExample;
